<div *ngIf="legacy">
<div class="row tp-selection">
  <div class="col-12">
    <p>Showing: {{dateLabel}}</p>
    <p><i>Data available from {{minYear}} to {{maxYear}}</i></p>
  </div>
</div>

<div *ngIf="layerDates?.length" class="row form-group">
  <app-month-picker [minDate]="layerDates[0]"
                    [maxDate]="layerDates[layerDates.length-1]"
                    [selectableYear]="selectableYear"
                    [monthsBefore]="durationMonths-1"
                    [currentDate]="date"
                    (currentDateChanged)="dateChange($event)"></app-month-picker>
</div>

<!-- <div class="row">
  <p>-</p>
  <app-time-slider [dates]="layerDates"
                    [(date)]="date"
                    [format]="dateFormat"
                    [numMonths]="durationMonths"
                    (dateChange)="dateChange()"></app-time-slider>
</div> -->

<div class="row form-group mt-3">
  <div class="col-xl-12 col-xxl-4">
    <label for="monthSelect">{{aggregationLabel}} (months)</label>
  </div>
  <div class="col-xl-12 col-xxl-8">
    <app-ranged-integer id="monthSelect"
                        [value]="durationMonths"
                        (valueChanged)="durationChanged($event)"
                        [min]="1"
                        [max]="12"></app-ranged-integer>
    <!-- <input id="monthSelect"
          type="number"
          [(ngModel)]="durationMonths"
          [min]="1"
          [max]="12"
          (ngModelChange)="durationChanged()"> -->
  </div>
</div>
</div>
<div *ngIf="!legacy">
  <span *ngIf="years?.length"><small><i>Data available {{years[0]}}-{{years[years.length-1]}}</i></small></span>

  <div class="row form-group">
    <div class="col-xl-12 col-xxl-4">
      <label for="yearSelect">year</label>
    </div>
    <div class="col-xl-12 col-xxl-8">
      <select [(ngModel)]="year"
              id="yearSelect"
              (ngModelChange)="yearChanged()"
              [disabled]="!selectableYear||!years?.length"
              class="form-control form-control-sm">
        <option *ngFor="let yr of years" [ngValue]="yr">{{yr}}</option>
      </select>
    </div>
  </div>

  <div class="row form-group">
    <div class="col-xl-12 col-xxl-4">
      <label for="periodSelect">period</label>
    </div>
    <div class="col-xl-12 col-xxl-8">
      <select [(ngModel)]="durationMonths"
              id="periodSelect"
              (ngModelChange)="durationChanged()"
              class="form-control form-control-sm">
        <option *ngFor="let d of durations" [ngValue]="d">{{d}} month{{(d>1)?'s':''}}</option>
      </select>
    </div>
  </div>

  <div class="row form-group">
    <div class="col-xl-12 col-xxl-4">
      <label for="monthSelect">to month</label>
    </div>
    <div class="col-xl-12 col-xxl-8">
      <select [(ngModel)]="month"
              id="themeSelect"
              (ngModelChange)="monthChanged()"
              class="form-control form-control-sm">
        <option *ngFor="let m of months; let ix = index" [ngValue]="ix">{{m}}</option>
      </select>
    </div>
  </div>

</div>
